import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { acceptAuth } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    api.post("/auth/google", { session_id: sid })
      .then(async ({ data }) => {
        if (data.pending) {
          sessionStorage.setItem("pvc_auth_info", data.message);
          return nav("/login", { replace: true });
        }
        const me = await acceptAuth(data);
        toast.success(`Signed in as ${me.email}`);
        nav(me.role === "superadmin" ? "/admin" : "/", { replace: true });
      })
      .catch((e) => {
        sessionStorage.setItem("pvc_auth_msg", errMsg(e));
        nav("/login", { replace: true });
      });
  }, [hash, nav, acceptAuth]);

  return <div className="min-h-screen bg-slate-950" data-testid="google-auth-callback" />;
}

export function GoogleButton({ label = "Continue with Google" }) {
  return (
    <button type="button" onClick={startGoogleLogin} data-testid="google-login-button"
      className="w-full h-11 rounded-lg border border-slate-700 bg-white text-slate-900 font-semibold text-sm flex items-center justify-center gap-2.5 hover:bg-slate-100 transition-colors">
      <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.2-.1-2.4-.4-3.5z" /></svg>
      {label}
    </button>
  );
}
